import { useDisclosure } from "@mantine/hooks";
import { Fragment, useState } from "react";

import { type Stamp } from "../../../../../interfaces/Stamps";
import HistoryModal from "../../../../shared/HistoryModal/HistoryModal";
import ScrollableTable from "../../../../shared/ScrollableTable/ScrollableTable";
import ShipsStampsListItem from "./ShipsStampsListItem";
const headers = [
  { name: "name", label: "Name" },
  { name: "image", label: "Image" },
  { name: "reports", label: "Assigned Logbooks/Reports" },
  { name: "del", label: "", width: 50 },
];

interface Props {
  stamps: Stamp[];
  isLoading: boolean;
  refetchStamps: () => void;
}

const ShipsStampsList = ({ stamps, isLoading, refetchStamps }: Props) => {
  const [
    historyModalOpened,
    { open: openHistoryModal, close: closeHistoryModal },
  ] = useDisclosure(false);
  const [selectedRow, setSelectedRow] = useState<Stamp | undefined>();

  const handleClose = () => {
    setSelectedRow(undefined);
    closeHistoryModal();
  };
  const handleOpen = (row: Stamp) => {
    setSelectedRow(row);
    openHistoryModal();
  };
  const renderRow = (data: { row: Stamp }) => {
    // eslint-disable-next-line react/prop-types
    return (
      <ShipsStampsListItem
        {...data.row}
        refetchStamps={refetchStamps}
        handleOpenHistoryModal={() => handleOpen(data.row)}
      />
    );
  };

  return (
    <Fragment>
      <ScrollableTable
        style={{ padding: 20 }}
        data={stamps}
        headers={headers}
        renderRow={renderRow}
        loading={isLoading}
        sortable
      />
      <HistoryModal
        opened={historyModalOpened}
        close={handleClose}
        elementName={selectedRow?.name}
        params={{ stampid: selectedRow?.stampid }}
        apiUrl="get-stamp-history"
      />
    </Fragment>
  );
};
export default ShipsStampsList;
